import {Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild} from '@angular/core';
import {FieldValue} from '../../core/definitions/object-view';
import {UiToolsService} from '../../core/ui-tools.service';

@Component({
  selector: 'app-object-view-field-value',
  templateUrl: './object-view-field-value.component.html',
  styleUrls: ['./object-view-field-value.component.scss']
})
export class ObjectViewFieldValueComponent implements OnChanges, OnDestroy {

  @ViewChild('textAreaElement') textAreaElement: ElementRef;
  @Input() fieldValue: FieldValue;
  @Input() edit: boolean;
  @Input() fieldValueClass: string;

  url = false;
  urlObject;
  imageObject;
  ILLEGAL_REF_ID_PREFIXES = ['ct_'];

  private stopSizeWatch;

  constructor(private uiToolsService: UiToolsService) {
  }

  ngOnChanges() {
    setTimeout(() => {
      this.setTextAreaHeight();
    }, 100);

    if (this.fieldValue.ref_id) {
      for (const checkPrefix of this.ILLEGAL_REF_ID_PREFIXES) {
        if (this.fieldValue.ref_id.indexOf(checkPrefix) === 0) {
          return;
        }
      }
      if (this.fieldValue.ref_id.indexOf('IMG-') === 0) {
        this.imageObject = {
          thumbnail_id: this.fieldValue.ref_id,
          object_type: this.fieldValue.ref_object_type
        };
      } else if (this.fieldValue.ref_id === 'url') {
        this.url = true;
      } else {
        this.urlObject = {
          artifact_id: this.fieldValue.ref_id,
          object_type: this.fieldValue.ref_object_type,
          meta_type: this.fieldValue.ref_meta_type
        };
      }
    }

    this.stopSizeWatch = this.uiToolsService.addWindowSizeListener(() => {
      this.setTextAreaHeight();
    });
  }

  ngOnDestroy(): void {
    if (this.stopSizeWatch) {
      this.uiToolsService.removeWindowSizeListener(this.stopSizeWatch);
    }
  }

  private setTextAreaHeight() {
    if (this.textAreaElement) {
      this.textAreaElement.nativeElement.style.height = 0;
      this.textAreaElement.nativeElement.style.height = this.textAreaElement.nativeElement.scrollHeight + 'px';
    }
  }
}
